<template>
  <div>
    <!-- Overlay cobre o conteúdo enquanto "loading" for true -->
    <b-overlay :show="loading" rounded="sm" spinner-small spinner-variant="info" opacity="0.6">
      <b-card-body>
        <b-card class="importContainer">
          <b-form>
            <!-- Seleção da Categoria -->
            <b-form-group label="Selecione o tipo de Ocorrência:">
              <!-- 1) Todos os Indicadores -->
              <div class="radio-option option-select mt-2">
                <label>
                  <input class="cursor" type="radio" value="todosIndicadores"
                    v-model="localOccurrence.selectedCategory" />
                  <span class="cursor">Todos os Indicadores</span>
                </label>
              </div>
              <!-- 2) Indicadores de Tela -->
              <div class="radio-option option-select mt-2">
                <label>
                  <input class="cursor" type="radio" value="indicadoresTela"
                    v-model="localOccurrence.selectedCategory" />
                  <span class="cursor">Indicadores de Tela</span>
                </label>
              </div>
              <!-- 3) Indicadores de Área -->
              <div class="radio-option option-select mt-2">
                <label>
                  <input class="cursor" type="radio" value="indicadoresArea"
                    v-model="localOccurrence.selectedCategory" />
                  <span class="cursor">Indicadores de Área</span>
                </label>
              </div>
            </b-form-group>

            <!-- Seleção de Turno -->
            <b-form-group label="Selecione o Turno:">
              <b-form-select class="custom-select-color" v-model="localOccurrence.selectedTurno" :options="turnos" />
            </b-form-group>

            <!-- Se a categoria for Indicadores de Tela -->
            <b-form-group v-if="localOccurrence.selectedCategory === 'indicadoresTela'" label="Selecione a Tela:">
              <b-form-select class="custom-select-color" v-model="localOccurrence.selectedTela" :options="listaTelas" />
            </b-form-group>

            <!-- Se a categoria for Indicadores de Área -->
            <div v-if="localOccurrence.selectedCategory === 'indicadoresArea'">
              <b-form-group label="Selecione a Tela:">
                <b-form-select class="custom-select-color" v-model="localOccurrence.selectedTela" :options="listaTelas"
                  @change="onTelaChange" />
              </b-form-group>
              <b-form-group label="Selecione a Área:">
                <b-form-select class="custom-select-color" v-model="localOccurrence.selectedArea"
                  :options="listaAreas" />
              </b-form-group>
            </div>

            <!-- Botões Salvar/Cancelar -->
            <b-row class="groupBtn">
              <div class="modal-buttons">
                <img class="action-btn" width="30" height="30" src="@/assets/salvar.png" title="Salvar"
                  @click="onSave" />
                <img class="action-btn ml-2 exit-btn" width="30" height="30" src="@/assets/sair.png" title="Cancelar"
                  @click="onClose" />
              </div>
            </b-row>
          </b-form>
        </b-card>
      </b-card-body>
    </b-overlay>
  </div>
</template>

<script>
import axios from 'axios';
import { urlMainAPI } from "@/global";
import { BOverlay } from 'bootstrap-vue';

export default {
  name: "TableOccurrenceModal",
  components: { BOverlay },
  props: {
    occurrenceTable: {
      type: Object,
      default: () => ({
        selectedCategory: "todosIndicadores",
        selectedTurno: "",
        selectedTela: "",
        selectedArea: ""
      })
    },
    screensAreas: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: true,
      localOccurrence: { ...this.occurrenceTable },
      turnos: [
        { value: "", text: "Selecione o Turno" },
        { value: "todos", text: "Todos os Turnos" }
      ],
      listaAreas: [],
      workshiftDescriptions: {}
    };
  },
  computed: {
    listaTelas() {
      let list = [];
      if (this.screensAreas && Object.keys(this.screensAreas).length > 0) {
        list = Object.keys(this.screensAreas).map(key => ({
          value: key,
          text: key
        }));
      } else {
        list = [
          { value: "Tela1", text: "Tela 1" },
          { value: "Tela2", text: "Tela 2" },
          { value: "Tela3", text: "Tela 3" }
        ];
      }
      return [{ value: "", text: "Selecione a Tela" }, ...list];
    }
  },
  created() {
    this.localOccurrence = { ...this.occurrenceTable };
    this.loadWorkshiftDescriptions();
    if (
      this.localOccurrence.selectedCategory === "indicadoresArea" &&
      this.localOccurrence.selectedTela
    ) {
      this.fetchAreas();
    }
  },
  watch: {
    "localOccurrence.selectedCategory"() {
      // Reseta todos os selects quando a categoria muda
      this.localOccurrence.selectedTurno = "";
      this.localOccurrence.selectedTela = "";
      this.localOccurrence.selectedArea = "";
      this.listaAreas = [];
    },
    "localOccurrence.selectedTela"() {
      if (this.localOccurrence.selectedCategory === "indicadoresArea") {
        this.fetchAreas();
        if (!this.listaAreas.find(area => area.value === this.localOccurrence.selectedArea)) {
          this.localOccurrence.selectedArea = "";
        }
      }
    },
    occurrenceTable(newVal) {
      this.localOccurrence = { ...newVal };
      if (
        this.localOccurrence.selectedCategory === "indicadoresArea" &&
        this.localOccurrence.selectedTela
      ) {
        this.fetchAreas();
      }
    }
  },
  methods: {
    async loadWorkshiftDescriptions() {
      try {
        const response = await axios.get(`${urlMainAPI}/getworkshift`);
        if (response.data && Array.isArray(response.data)) {
          const workshifts = response.data;
          this.turnos = [
            { value: "", text: "Selecione o Turno" },
            { value: "todos", text: "Todos os Turnos" }
          ];
          workshifts.forEach(shift => {
            if (shift.id >= 1 && shift.id <= 3) {
              this.turnos.push({
                value: shift.description,
                text: shift.description
              });
            }
            if (shift.id === 4) {
              this.turnos.push({
                value: "DIA",
                text: shift.description
              });
            }
          });
        }
      } catch (error) {
        console.error('Erro ao carregar descrições dos turnos:', error);
        // Fallback para valores padrão em caso de erro
        this.turnos = [
          { value: "", text: "Selecione o Turno" },
          { value: "todos", text: "Todos os Turnos" },
          { value: "A", text: "Turno A" },
          { value: "B", text: "Turno B" },
          { value: "C", text: "Turno C" },
          { value: "DIA", text: "Dia" }
        ];
      } finally {
        // Seja sucesso ou erro, esconde o loader
        this.loading = false;
      }
    },
    fetchAreas() {
      if (
        this.localOccurrence.selectedTela &&
        this.screensAreas[this.localOccurrence.selectedTela]
      ) {
        this.listaAreas = this.screensAreas[this.localOccurrence.selectedTela].map(area => ({
          value: area,
          text: area
        }));
        this.listaAreas.unshift({ value: "", text: "Selecione a Área" });
      } else {
        this.listaAreas = [{ value: "", text: "Selecione a Área" }];
      }
    },
    onTelaChange() {
      this.fetchAreas();
      this.localOccurrence.selectedArea = "";
    },
    onSave() {
      this.$emit("save", { ...this.localOccurrence });
    },
    onClose() {
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.modal-title {
  text-align: center;
  margin-bottom: 15px;
  font-size: 18px;
}

.radio-option {
  margin-bottom: 10px;
}

.radio-option label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 16px;
}

.select-indicador {
  max-width: 100%;
  padding: 5px;
  border: 1px solid #ccc;
  font-size: 16px;
  outline: none;
  background-size: 12px;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.modal-buttons {
  text-align: right;
  cursor: pointer;
}

.action-btn {
  border: none;
  background: transparent;
  cursor: pointer;
}

.exit-btn {
  margin-left: 14px;
  margin-right: 14px;
}

.cursor {
  cursor: pointer;
}

.radio-top {
  margin-top: 20px;
}

.option-select input[type="radio"] {
  accent-color: #009a9a;
  /* cor do "check" do radio */
  cursor: pointer;
}

.custom-select-color {
  border: 1px solid #009a9a !important;
  border-radius: 4px;
  padding: 5px;
  font-size: 16px;
}

.custom-select-color:focus {
  border-color: #009a9a !important;
  box-shadow: 0 0 0 0.2rem rgba(0, 154, 154, 0.25) !important;
}
</style>
